import api from "./index";

export const getGuestListing = async (management_token) => {
  const res = await api.get(`/listings/guest/${management_token}`);
  return res.data;
};

export const updateGuestListing = async (management_token, data) => {
  const res = await api.put(`/listings/guest/${management_token}`, data);
  return res.data;
};

export const deleteGuestListing = async (management_token) => {
  const res = await api.delete(`/listings/guest/${management_token}`);
  return res.data;
};
